import * as React from 'react';
import { GoogleReCaptchaProvider, withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { WebformWrapper, IWebformWrapperProps } from './WebformWrapper';
import { AppContext } from './Types/Intyg.types';

const WrappedForm = withGoogleReCaptcha(WebformWrapper);

export function ReCaptchaWrapper(props: IWebformWrapperProps) {
  const appContext = React.useContext(AppContext);
  return (
    <GoogleReCaptchaProvider reCaptchaKey={appContext.clientKey}>
      <WrappedForm {...props} />
    </GoogleReCaptchaProvider>
  );
}
